import { Component, h, Prop, Host, Element } from '@stencil/core';
import appendDescribedBy from '../_util/appendDescribedBy';

/**
 * @description form-kit: Displays help text under a form input
 *
 * @formkit
 * @since 6.0.0
 * @use
 */
@Component({
  tag: 'hp6-help-text',
  styleUrl: 'help-text.scss',
  shadow: true,
})
export class HelpText {
  /**
   * The id of the form element for which this is the label
   */
  @Prop({ attribute: 'for' }) htmlFor!: string;

  /**
   * The help text to display under the form input
   */
  @Prop() helpText: string;

  /**
   * The alignment of the help-text
   *
   * Used as prop rather than attribute in input-text, so reflect: true is needed
   */
  @Prop({ reflect: true }) alignmentSelection: 'left' | 'center' = 'left';

  @Element() host: HTMLElement;

  get forElement() {
    return document.querySelector(`#${this.htmlFor}`);
  }

  componentDidLoad() {
    const { forElement, htmlFor } = this;
    if (forElement) {
      // add help-text to the list of aria-describedby elements
      appendDescribedBy(forElement as HTMLElement, `${htmlFor}-help-text`);
    }
  }

  /**
   * render()
   *
   * @returns tsx
   */
  render() {
    const { helpText, htmlFor } = this;
    return <Host id={`${htmlFor}-help-text`}>{helpText}</Host>;
  }
}
